<template>
  <div class="modal">
    <v-dialog :value="value1" @input="$emit('input1')" max-width="800">
      <v-card>
        <v-card-title align="center" class="headline">
          Search result for keysearch: &nbsp;&nbsp;
          <strong>{{keysearch}}</strong>
        </v-card-title>
        <v-card-text>
          <!-- <p>
            <i><strong>Note</strong>: These data might be old and the number are not correct.</i>
          </p>-->
          <v-data-table
            :headers="headers"
            :items="items"
            :items-per-page="5"
            :options.sync="pagination"
            :server-items-length="totalItems"
            class="elevation-1"
          >
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="(item, index) in items" :key="item.name">
                  <td>
                    <a
                      :href="'https://www.instagram.com/' + item.instagramHandle"
                      target="_blank"
                    >@{{item.instagramHandle}}</a>
                  </td>
                  <td>{{item.totalFollowers}}</td>
                  <td>{{item.engagementRate}}%</td>
                  <td>{{item.audienceCredibility}}%</td>
                  <td>{{item.relevancyScore}}</td>
                  <td>
                    <v-btn
                      v-if="!item.isSelected"
                      @click.stop="selectInfluencer(item, index)"
                      color="secondary"
                      fab
                      x-small
                    >
                      <v-icon>done</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="item.isSelected"
                      @click.stop="deselectInfluencer(item, index)"
                      color="red"
                      fab
                      x-small
                      dark
                    >
                      <v-icon>clear</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click.stop="close">Done</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: 'InfluencerListModal',
  props: {
    result: Object,
    value1: Boolean,
    keyword: Array,
    influencers: Array // Selected influencers
  },
  data() {
    return {
      keysearch: '',
      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['relevancyScore'],
        sortDesc: [true]
      },
      selectedInfluencers: [],
      totalItems: 0,
      headers: [
        {
          text: 'Handle',
          sortable: false
        },
        { text: 'Followers', sortable: true, value: 'totalFollowers' },
        { text: 'Eng. Rate', sortable: true, value: 'engagementRate' },
        { text: 'Aud. Cred', sortable: true, value: 'audienceCredibility' },
        { text: 'Relevancy', sortable: true, value: 'relevancyScore' },
        { text: 'Act.', sortable: false }
      ],
      items: [],
      originalItems: []
    };
  },
  computed: {},
  watch: {
    result(data) {
      this.totalItems = data.totalItems;
      this.originalItems = data.originalItems;
      this.paginate();
    },
    influencers(value) {
      this.selectedInfluencers = Object.assign([], value)
    },
    pagination() {
      this.paginate();
    },
    keyword(value) {
      this.keysearch = value.join(', ')
    }
  },
  methods: {
    close() {
      this.$emit('input1');
    },
    isSelected(igHandle) {
      let index = this.selectedInfluencers.findIndex(item => item === igHandle);
      return index;
    },
    selectInfluencer(influencer, i) {
      let index = this.isSelected(influencer.instagramHandle);
      if (index === -1) {
        this.selectedInfluencers.push(influencer.instagramHandle);
        this.items[i].isSelected = true;
        this.items.splice();
        this.$emit('select', influencer.instagramHandle)
      }
    },
    deselectInfluencer(influencer, i) {
      let index = this.isSelected(influencer.instagramHandle);
      this.selectedInfluencers.splice(index, 1);
      this.items[i].isSelected = false;
      this.items.splice();
      this.$emit('select', influencer.instagramHandle)
    },
    updateItems(influencers) {
      const displayItems = influencers.map(element =>
        Object.assign(
          { id: element._id },
          {
            instagramHandle: element.instagram ? element.instagram.instagramHandle : null,
            instagramID: element.instagram ? element.instagram.instagramID : null,
            totalFollowers: element.instagram ? element.instagram.totalFollowers : 0,
            audience: element.audience || {},
            instagram: element.instagram || {},
            relevancyScore: element.relevancyScore ? Number(element.relevancyScore).toFixed(2) : 0,
            engagementRate:
              element.audience && element.audience.user_profile
                ? (Number(element.audience.user_profile.engagement_rate) * 100).toFixed(2)
                : 0,
            isSelected: this.isSelected(element.instagram ? element.instagram.instagramHandle : '') !== -1,
            audienceCredibility:
              element.audience &&
              element.audience.audience_followers &&
              (element.audience.audience_followers.success || element.audience.audience_followers.data)
                ? Number(element.audience.audience_followers.data.audience_credibility * 100).toFixed(2)
                : 0
          }
        )
      );
      this.items = displayItems;
    },
    paginate() {
      let { page, sortBy, sortDesc, itemsPerPage } = this.pagination;
      if (sortBy.length === 1 && sortDesc.length === 1) {
        this.sort(sortBy[0], sortDesc[0]);
      }
      let items = this.originalItems.slice((page - 1) * itemsPerPage, itemsPerPage * page);
      this.updateItems(items);
    },
    sort(sortBy, descending) {
      let sortCriteria = '';
      switch (sortBy) {
        case 'totalFollowers':
          sortCriteria = 'instagram.totalFollowers';
          break;
        case 'engagementRate':
          sortCriteria = 'audience.user_profile.engagement_rate';
          break;
        case 'audienceCredibility':
          sortCriteria = 'audience.audience_followers.data.audience_credibility';
          break;
        case 'relevancyScore':
          sortCriteria = 'relevancyScore';
          break;
        default:
          sortCriteria = 'relevancyScore';
      }
      this.originalItems.sort((a, b) => {
        let prev = this.getValueByPath(a, sortCriteria);
        let last = this.getValueByPath(b, sortCriteria);
        if (descending) {
          return last > prev ? 1 : last < prev ? -1 : 0;
        }
        return last > prev ? -1 : last > prev ? 1 : 0;
      });
    },
    getValueByPath(obj, path) {
      let val = obj;
      let paths = path.split('.');
      paths.forEach(p => {
        if (val) val = val[p];
      });
      return Number(val || 0);
    }
  }
};
</script>



// WEBPACK FOOTER //
// InfluencerListModal.vue?f13d6d38